import ProfileIdentity from './ProfileIdentity';
import ProfileIdentityContainer from './ProfileIdentity.container';

export default ProfileIdentityContainer(ProfileIdentity);
